//fix bug from chessground library
export const fixBug = () => {
  const x = document.getElementsByClassName("cg-custom-svgs");
  x[0].style.position = "absolute";
};

// set chessboard color
export const setChessboardColor = (chessboardColor) => {
  const board = document.getElementsByClassName("cg-wrap");
  const possibleColors = ["color-black", "color-brown", "color-gray"];
  board[0].classList.add(chessboardColor);
  possibleColors.map((color) => {
    if (color !== chessboardColor) {
      board[0].classList.remove(color);
    }
  });
};
